import LeadInCopy from './component.jsx'
export default LeadInCopy
